
(function ($) {
    class SurveyCustomer{
        constructor(container){
            this.container = $(`.${container}`)
            this.addeventlistener()
            this.url = 'https://script.google.com/macros/s/AKfycbzFQgtU732OvobLP-whufJ6oDq4Lyl7CRJAjNhwfCcsp4DBuuQ8ChhbypjGlMUxLCQ_FA/exec'
            this.submit = $(".btn-submit-survey")
        }
    }
    SurveyCustomer.prototype.call = function(data){
        var scriptURL = this.url
        var submit_btn = this.submit
        console.log({data})
        $.ajax({
            type: 'POST',
            url: scriptURL,
            data: data,
            contentType: 'application/x-www-form-urlencoded',
            beforeSend: function () {
                submit_btn.addClass("disabled");
                submit_btn.html("Sending...")
              $("#state").html("running")
            },
            success: function (response) {
                submit_btn.removeClass("disabled");
                submit_btn.html("Your message has been sent.")
            },
            error:function(e){
             console.log(e)
                submit_btn.html("Send message")
            }
  
          })
    }
    SurveyCustomer.prototype.addeventlistener = function(){
        var _this = this;

        this.container.find(".text-with-icons__list").on("click",">div",function(){
            _this.choice(this)
        })

        this.container.on("click",".btn-submit-survey",function(){
            _this.actionForm(this)
        })
        // .on("focusout","input",function(){
        //     _this.messageInput(this)
        // }).on("keypress","input",function(){
        //     _this.clearError(this)
        // })

    }
    SurveyCustomer.prototype.clearError = function(el){
        var block = $(el).closest(".form-control")
        block.find(".msg-error").remove()
    }
    SurveyCustomer.prototype.addErrorMsg = function(block){
        if(block.find(".msg-error").length > 0) return
            var msg = `<span class="msg-error">Translation missing: en.contact.form.error_message</span>`
            block.append(msg)
            return; 
    }
    SurveyCustomer.prototype.messageInput = function(el){
        var content = $(el).val()
        var block = $(el).closest(".form-control")
        var name = $(el).attr("name")
        if(name == 'contact[email]'){
            var is_valid = this.validEmail($(el).val())
            if(is_valid == false){
                this.addErrorMsg(block)
                return;
            }
        }
        if(!content){
            this.addErrorMsg(block)
            return;  
        }
        this.clearError(el)
    } 
    SurveyCustomer.prototype.getRadio = function(){
        var data_default = {"customer_service":3,"delivery":3,"quanlity":3};
        var data = []
        var temp = {}
        this.container.find("input[type=radio]:checked").each(function(){ 
            var item = $(this).serializeArray()[0]
            temp[item.name] = parseInt(item.value)
        })

        var combine = {...data_default,...temp}
        
        $.each(combine,function(index,value){
            var item = {name:index,value}
            console.log({item})
            data.push(item)
        })

        return data;
    }
    
    SurveyCustomer.prototype.actionForm = function(el){
        var contact_data = this.form_data(el)
        var is_valid = this.is_valid(contact_data)
        console.log({is_valid})
        if(is_valid == false){
            this.container.find("input").trigger("focusout")
            return;
        }
        
        var radio_data = this.getRadio()
        var data = [...contact_data,...radio_data]
        this.call(data)
        
    }
    SurveyCustomer.prototype.form_data = function(el){
        return $(el).closest("form").serializeArray()

    }
    SurveyCustomer.prototype.setColor = function(el){
        $(el).closest(".text-with-icons").find(".icon-block").removeClass("checked")
        $(el).addClass("checked")
    }
    SurveyCustomer.prototype.getHeightHeader = function(){
        if($("header").length > 0){
            return $("header").height()
        }
        return 0;
    }
    SurveyCustomer.prototype.getHeightAside = function(){
        if($("aside").length > 0){
            return $("aside").height()
        }
        return 0;
    }
    SurveyCustomer.prototype.autoScrollNextSection = function(el){
        var next = $(el).closest("section").next()
        var new_position = next.offset().top - this.getHeightHeader() - this.getHeightAside() - 10
        if(next.length > 0){
            $("html, body").animate({ scrollTop: new_position }, 1000);
        }
    }
    SurveyCustomer.prototype.choice = function(el){
        var icon = $(el).find(".icon-block")
        this.setColor(icon)

        $(el).find("input").prop("checked", true);
        this.autoScrollNextSection(el)
    }
    SurveyCustomer.prototype.send = function(){

    }
    SurveyCustomer.prototype.is_valid = function(data){
        var is_valid = true;
        // var _this = this
        // $(data).each(function(index,item){
        //     if(item.value == '' && item.name !='message'){
        //         is_valid = false;
        //         return;
        //     }
        //     if(item.name == 'email'){
        //         is_valid = _this.validEmail(item.value)
        //         if(is_valid == false) return
        //     }
        // })
        return is_valid;
    }
    SurveyCustomer.prototype.validEmail = function(value){
        var reg = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
        return reg.test(value)
    }
    class SlimcaseVariants{
        constructor(){
            this.addeventlistener()
        }
    }
    SlimcaseVariants.prototype.addeventlistener = function(){
        var _this = this;

        // $(".product-info").on("click",".variant_option",function(){
        //     // console.log("click option")
        //     _this.changeType(this)
        // })

        // $(".color-swatch").on("click",function(){ 
        //     _this.changeColor(this)
        // })
        $(".variant-picker__option-values[data-option-selector]").on("click","input",function(){
            _this.changeVariantSamSung(this)
        })
    }
    SlimcaseVariants.prototype.changeVariantSamSung = function(el){
        $(".variant-picker__option-values[data-option-selector]").find("label").removeClass("active")
        $(el).next().addClass("active")
    }
    SlimcaseVariants.prototype.showColor = function(type){
        type = type.toLowerCase()
        
        $(".color-list").find(`label[data-type]`).each(function(){
            var data = $(this).data()
            $(this).removeClass("active")

            if(data.type.toLowerCase() == type){
                $(this).addClass("show")
                return;
            }

            $(this).removeClass("show")
        })

        $(".color-list").find(`label.show`).first().trigger("click")

    }
    SlimcaseVariants.prototype.activeColor = function(value){

    }
    SlimcaseVariants.prototype.changeType = function(el){
        
        $(".product-info").find(".card").removeClass("active")
        $(el).closest(".card").addClass("active")

        var type = $(el).val().trim()
        // change title
        $(".choose-variants").find(".case-type__title").html(type)

        this.showColor(type)

    }
    SlimcaseVariants.prototype.changeColor = function(el){
        $(".color-list").find(".color-swatch").removeClass("active")
        $(el).addClass("active")
        var data = $(el).data()

        // title
        var title = data.color

        $(".title-color.variant-picker__option-info").find(".case-type__title").html(title)

        // check variants
        var variant_selected = `${data.type} - ${data.color}`
        variant_selected = variant_selected.replaceAll(" ","")

        $("variant-picker").find(".variant-picker__option-values").find("input").each(function(){
            var value = $(this).val()
            value = value.replaceAll(" ","")
            if(variant_selected == value){
                $(this).click()
            }
        })
    }
    function resetForm(){
        alert(" You have successfully registered ");
        $('#name-notify').val('');
        $('#phone-notify').val('');
        $('#message-notify').val('');
        $('#modal-notify').hide();
        $('#variant-notify').val('');
        $('#variant-id-notify').val('');
        $('#type-notify').val('');
    
    }
    function getCurrentDay(){
        var date = new Date()
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    }
    function getType(){
    var type = $(".title-variants.variant-picker__option-info")?.find("span")?.html()?.trim();
    if(!type){
        return "None";
    }
    return type;
  }
  function getVariant(){
        
        var element = $(".product-info__inventory")?.find("variant-inventory")?.find("[data-state]:not([hidden])")?.data()
        if(element){
            var data = {}
            if(element.variantId){
                data.Variant_id = element.variantId
            }
            data.Variant = $(".title-color.variant-picker__option-info")?.find("span")?.html()?.trim()
            if(!data.Variant){
                const product = document.querySelector("form[is=product-form]")
                const input = product.querySelector("input[name='id']")
                if(input){
                    return {Variant_id: input.value}
                }
                data.Variant = "None"
            }
        
            return data;
        }
        
        return {Variant_id: ''};
    }
  function getDataNotify() {
    var data = getVariant();
    // form.forEach((value, key) => data[key] = value);
    var form_data = $("#modal-notify form")
      .serializeArray()
      .reduce(function (obj, item) {
        obj[item.name] = item.value;
        return obj;
      }, {});

    data.Type = getType();
    data.Create_time = getCurrentDay();
    return { ...data, ...form_data };
  }

  class ScreenProtectorSection {
    constructor() {}
  }
  ScreenProtectorSection.prototype.getClassBy = function (value) {
    var data = {
      "Black Edge": ".screen-protector-section.black-edge",
      "Clear Edge": ".screen-protector-section.clear-edge",
    };
    return data[value] ?? ".screen-protector-section.black-edge";
  };
  ScreenProtectorSection.prototype.show = function (value) {
    var selector = this.getClassBy(value);
    $(".screen-protector-section").hide();
    $(`${selector} .section-revealed-image`).show().css("display", "inline");
    $(selector).show();
  };
  ScreenProtectorSection.prototype.addeventlistener = function () {
    var _this = this;
    $(".variant-picker__option input").on("change", function () {
      var value = $(this).val();
      _this.show(value);
    });
  };
  ScreenProtectorSection.prototype.init = function () {
    var value = $(".variant-picker__option input:checked").val();
    this.show(value);
    this.addeventlistener();
  };

    $(document).ready(function () {
        if($("variant-picker-custom").length > 0) {
            new SlimcaseVariants()
        }

        new SurveyCustomer('survey-customer')
        new ScreenProtectorSection().init()

        // Hide text "Tạm hết hàng" when Pre-order 
        $("[data-state='oversell_stock']").text("");

    function triggerClickBlockSwatch(value) {
      $(".product-info__variant-picker")
        .find(`input[value="${value}"] + label`)
        .trigger("click");
      $(".case-info-section").hide();

      const sectionMap = {
        Rover: ".case-info-section.case-rover",
        Unique: ".case-info-section.case-unique",
        Pro: ".case-info-section.case-pro",
        Rex: ".case-info-section.case-rex",
        Sport: ".case-info-section.case-sport",
        Pop: ".case-info-section.case-pop",
        "Classic 2": ".case-info-section.case-classic2",
        "Standout": ".case-info-section.case-standout",
      };

      for (const key in sectionMap) {
        if (value.includes(key)) {
          $(sectionMap[key]).show();
          $(sectionMap[key] + ".section-revealed-image")
            .show()
            .css("display", "inline");
          return;
        }
      }

      // Default case
      $(".case-info-section.case-classic").show();
    }

        // Assuming the current variant is indicated by a specific class or is the first option
        let currentValue = $('.item-variants.variant-picker__option-values .card.active  .variant_option').val() || $('.item-variants.variant-picker__option-values .variant_option').first().val();
            
        if(currentValue) {
            triggerClickBlockSwatch(currentValue);
        }

        $(".item-variants.variant-picker__option-values").on('change', '.variant_option', function (e) {
            
            let value = $(this).val();
            triggerClickBlockSwatch(value);
            
        });

        // form notify 
        $("#modal-notify").on('click','.home-modal-close',function(e){
            e.preventDefault();
            $('#modal-notify').css('display','none');
          })
        
          $(document).on('click','#popup-notify',function(e){
            e.preventDefault(); // Now link won't go anywhere
            e.stopPropagation(); // Now the event won't bubble up
            $('#modal-notify').css('display','block');
          })

          $("#modal-notify").on('click','.btn-send-notify',function(e){ 
            
            e.preventDefault();
            if($(e.target).hasClass("disabled")){
                return false;
            }
            var check = true;
            $('.required-input').each(function(i,v){
              if($(this).val().trim() == ''){
                $(this).addClass('valid-error');
                check = false;
              }
            })
            if(check){
                const scriptURL = 'https://script.google.com/macros/s/AKfycbz_pkVNuxmset9wjm1SHRpKBNkIB016etOgcyhkQwlUKfGZePKtwKyy3710kThfbhSY/exec';
                var data = getDataNotify()
            $.ajax({
                  type: 'POST',
                  url: scriptURL,
                  data: data,
                  contentType: 'application/x-www-form-urlencoded',
                  beforeSend: function () {
                    $(".btn.btn-send-notify").addClass("disabled");
                    $(".btn.btn-send-notify").html("Sending...")
                    $("#state").html("running")
                  },
                  success: function (response) {
                    $(".btn.btn-send-notify").removeClass("disabled");
                    $(".btn.btn-send-notify").html("Registry")
                    resetForm()
                  },
                  error:function(e){
                   console.log(e)
                   $(".btn.btn-send-notify").html("Registry")
                  }
        
                })
            }
          })
          
    });
})(jQuery);